/**
 * "Data handling & retention" — Trust section (ADR-0074).
 * Reconciled from the CLI ZDR gate (packages/cli/src/enrich/providers, ADR-0015:
 * ≤2 KB redacted handler text, sent only when ZDR is confirmed; managed mode
 * hard-refuses otherwise) and the retention policy in product/trust/privacy.md
 * (presented as a per-plan commitment — automated purge is not yet code-enforced,
 * so phrased "retained for up to N", not "auto-deleted"). Links to /trust/privacy.
 */
import type { DocPageContent } from '../types';

export const TRUST_DATA_PAGE: DocPageContent = {
  slug: 'trust/data',
  titleKey: 'docs.trust.data.title',
  descriptionKey: 'docs.trust.data.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.trust.data.lead' },

    { kind: 'heading', level: 2, id: 'what', textKey: 'docs.trust.data.what.heading' },
    { kind: 'paragraph', textKey: 'docs.trust.data.what.body' },
    {
      kind: 'definitions',
      items: [
        {
          termKey: 'docs.trust.data.kind.catalog.term',
          descKey: 'docs.trust.data.kind.catalog.desc',
        },
        { termKey: 'docs.trust.data.kind.chat.term', descKey: 'docs.trust.data.kind.chat.desc' },
        {
          termKey: 'docs.trust.data.kind.knowledge.term',
          descKey: 'docs.trust.data.kind.knowledge.desc',
        },
      ],
    },

    { kind: 'heading', level: 2, id: 'zdr', textKey: 'docs.trust.data.zdr.heading' },
    { kind: 'paragraph', textKey: 'docs.trust.data.zdr.body' },
    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.trust.data.zdr.cli.title',
      textKey: 'docs.trust.data.zdr.cli.body',
      links: {
        cli: { target: { docSlug: 'cli/init' }, labelKey: 'docs.trust.data.zdr.cli.link' },
      },
    },
    {
      kind: 'list',
      itemKeys: [
        'docs.trust.data.zdr.item.sends',
        'docs.trust.data.zdr.item.never',
        'docs.trust.data.zdr.item.consent',
      ],
    },

    { kind: 'heading', level: 2, id: 'retention', textKey: 'docs.trust.data.retention.heading' },
    { kind: 'paragraph', textKey: 'docs.trust.data.retention.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.trust.data.retention.item.conversations',
        'docs.trust.data.retention.item.audit',
        'docs.trust.data.retention.item.operational',
        'docs.trust.data.retention.item.shorten',
      ],
    },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.trust.data.retention.note.title',
      textKey: 'docs.trust.data.retention.note.body',
      links: {
        privacy: { target: { path: '/trust/privacy' }, labelKey: 'docs.trust.common.link.privacy' },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.trust.data.next.privacy.title',
          textKey: 'docs.trust.data.next.privacy.text',
          to: { docSlug: 'trust/privacy' },
        },
        {
          titleKey: 'docs.trust.data.next.byok.title',
          textKey: 'docs.trust.data.next.byok.text',
          to: { docSlug: 'billing/byok' },
        },
      ],
    },
  ],
};
